import React from "react";

import ReportAudits from "./components/audits.js";
import ReportCourses from "./components/courses.js";
import ReportTrainerCourses from "./components/trainer-courses.js";
import ReportCoursesInstructor from "./components/courses-instructor.js";
import ReportFinance from "./components/finance.js";

export default function ReportsOverview() {
    return (
        <div>
            <div className="section-top">
                <h1>Rapporten</h1>
            </div>

            <ReportAudits />
            <hr className="mt-5 mb-4" />
            {/* todo: enable again after release */}
            {/*<ReportFinance />
            <hr className="mt-5 mb-4" />*/}
            <ReportCourses />
            <hr className="mt-5 mb-4" />
            <ReportTrainerCourses />
            <hr className="mt-5 mb-4" />
            <ReportCoursesInstructor />
            <hr className="mt-5 mb-4" />
        </div>
    );
}
